<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="main-container">
          <!-- <b-modal centered  ref="myModalRef" hide-footer no-close-on-backdrop size="lg" class="modal-md modal-content" role="document">
            <div slot="modal-header" style="text-align: center !important;">
              <b-btn class="close custom-modal__close" style="justify-content: center !important; font-size: .89em;" @click="hideModal"> <span aria-hidden="true" class="fa fa-close"></span></b-btn>
              <img src="/static/img/modal/8.png" alt="" class="">
              <h2 class="page-content__header-description">Add Inventory</h2>
            </div>

            <div class="d-block text-center">
              <div class="col-md-12" style="flex-flow: column; display: flex;">
                <b-form-select v-model="componentForm.componentId" :options="componentOptions" @change="fetchComponentTypes" placeholder="Select Component" class="mb-3" style="text-transform: capitalize !important">
                </b-form-select>
                <b-form-select v-model="componentForm.componentTypeId" :options="componentTypeOptions" placeholder="Select Component" class="mb-3" style="text-transform: capitalize !important">
                </b-form-select>
                <div style="width:100%">
               <div v-if="multiple"  style="width:90%;float:left">
                  <input type="text" class="form-control col-md-6"  v-model="serialForm.min" placeholder="Mininum Serial No">
                  <input type="text" class="form-control col-md-6"  v-model="serialForm.max" placeholder="Maximum Serial No">
                </div>
                <div v-else style="width:90%;float:left">
                  <input type="text" class="form-control form-control-lg" id="componentForm_batch" v-model="componentForm.serialNumber" placeholder="Serial Number">
                </div>
                <div style="width:9%;float:left">
                 <b-button class="form-control btn btn-primary"  @click="multiple=!multiple">
                  &nbsp; <span class="fa fa-clone"></span>
                </b-button>
                </div>
                </div>
                <b-button size="" class="btn btn-primary" @click="addInventory" style="margin-top: 12px;">
                  Add &nbsp; <span class="fa fa-plus"></span>
                </b-button>
              </div>
            </div>
          </b-modal>  -->

        <vue-good-table
          :columns="fields"
          :rows="componentData"
          :search-options="{enabled: true,
            externalQuery: searchTerm}"
          :pagination-options="{enabled: true}"
          :lineNumbers="true"
          @on-row-click="tableRowClicked"
          styleClass="table table-striped col-md-12"
        >
          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :total="props.total"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
            ></grey-pagination>
          </template>
        </vue-good-table>

          <div class="row">
            <can I='create' a='inventory'>
            <div class="page-content__header-description col-md-12" style="line-height: 35px; padding-bottom: 14px; border-bottom: 1px solid rgba(200, 200, 200, 0.3);">
              Inventory Overview
              <b-button variant="primary" class="pull-right" @click="showModal">
                Add Inventory
              </b-button>
            </div>
            </can>
            <!-- ======================= -->
            <!-- v-if="inventoryCount[row.id]>0" -->
             <div class="col-xl-3 col-lg-3 col-md-3 text-center" v-for="(row, index) in rows" :key="index">
              <div class="widget_box">
                <figcaption>
                  <h3 style="text-transform: capitalize;">{{componentName[row.id]}} {{row.name}}</h3>
                  <h5 style="font-size: 2em;">{{ (inventoryCount[row.id]) || 0}}</h5>
                </figcaption>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";

  export default {
    data() {
      return {
        multiple: true,
        responseData: '',
        rows: [],
        fields: [
        {
          label: "Name",
          key: "name",
          field: "name",
          sortable: "true"
        }
        // {
        //   label: "Description",
        //   key: "description",
        //   field: "description",
        //   sortable: "true"
        // }
      ],
        inventoryCount: {},
        componentName:[],
        componentForm: {
          componentId: null,
          componentTypeId: null,
          serialNumber: null,
          type: 'component',
          userId:0,
        },
        serialForm:{
          min: null,
          max: null,
        },
        componentOptions: [{
          value: null,
          disabled: true,
          text: "Select component"
        }
      ],
      componentTypeOptions: [
        {
          value: null,
          disabled: true,
          text: "Select component type"
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices",
      "getUserSession"
    ]),
    b: function() {
      // `this` points to the vm instance
      return this.inventoryCount;
    },
    inventoryCounter: {
      // getter
      get: function() {
        return this.inventoryCount;
      },
      // setter
      set: function(newValue) {
        this.inventoryCount = newValue;
      }
    }
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    fetchComponentTypes(selectedCompId) {
      console.log(selectedCompId);
      if (selectedCompId !== null) {
        const context = this;
        const HTTP = this.$httpUtils.instance;
        const url = `/components/${selectedCompId}/componentTypes`;
        HTTP.get(url)
          .then(response => {
            const componentList = response.data;
            componentList.filter(x => {
              x.value = x.id;
              x.text = x.name;
            });
            context.componentTypeOptions=[
              ...context.componentTypeOptions,
              ...componentList
            ]
        })
      }
      },
       validateRequestForm() {
        for (let [field, value] of Object.entries(this.componentForm)) {
          if (value === null || value === "") {
            return 'Please fill all fields!'
          }
        }
        return true;
      },
      addInventory(){
        let url = "/inventories";
          if(this.multiple){
            this.componentForm.serialNumber=`${this.serialForm.min}->${this.serialForm.max}`
            url = "/inventories/multiple";
          }
        if (this.validateRequestForm() === true) {
         this.componentForm.userId = this.getUserSession.id;
          const container = this;
          const HTTP = this.$httpUtils.instance;
          HTTP.post(url, this.componentForm)
            .then(response => {
              container.showSuccessMsg({message: response.data+'\nComponent(s) Added'});
              container.hideModal();
              container.getComponents();
            })
            .catch(error => {
              var errorMsg = error.response.data.error.details.messages;
              var errTemp = []
              var keyHooks = Object.keys(errorMsg);
              Object.values(errorMsg).map((x, index) => {
                errTemp[index] = keyHooks[index] + ' ' + x[0]
              });
              errTemp = Object.values(errTemp).join('<br>');
              container.showErrorMsg({
                message: errTemp
              });
            });
        } else {
          this.showErrorMsg({
            message: this.validateRequestForm()
          });
      }
    },
      random_num: (dumm) => {
        return Math.floor(Math.random(9999) * 9999);
      },
      showModal() {
        this.$refs.myModalRef.show()
      },
      hideModal() {
        this.$refs.myModalRef.hide()
      },
      getComponentName(param) {
        try {
          return this.componentOptions.filter(x => x.value == param)[0].name
        } catch (error) {
          return ''
        }
      },
      getComponents() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
        HTTP.get(`/component_types/?filter={"include": ["component"]}`, {}).then(components => {
          container.rows = components.data;
          components.data.forEach(element => {
            this.componentName[element.id]=element.component.name;
            container.getComponentCount(element.id)
          });
      })
    },
    random_num: dumm => {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },
    getComponentCount(compType) {
      const HTTP = this.$httpUtils.instance;
      const self = this;

        HTTP.get(`/inventories/count/?where=`+JSON.stringify({"componentTypeId":compType,"status": 0})).then(count => {
          self.inventoryCount[compType] = count.data.count;
          var temp = Object.assign({}, self.inventoryCount);
          temp[compType] = count.data.count
          self.inventoryCounter = temp
          console.log(self.inventoryCounter )
        });
        // self.setAccessLocal(saveRole.join);
      }
    },
    mounted() {
    if (!this.$can("read", "inventory")) {
      this.$router.push({ path: "/" });
      return;
    }

      // const HTTP = this.$httpUtils.instance;
      // const container = this;
      // HTTP.get("/components/", {}).then(components => {
      //   const componentFetch = components.data;
      //   componentFetch.filter(x => {
      //     x.value = x.id;
      //     x.text = x.name;
      //   });
      //   componentFetch.unshift({
      //     value: null,
      //     disabled: true,
      //     text: "Select Component"
      //   });
      //   container.componentOptions = componentFetch;
      //   // container.setAccessLocal(saveRole.join);
      // }).then(this.getComponents());

      // HTTP.get("/component_types/", {}).then(components => {
      //   container.rows = components.data;
      // });
    },
  };
</script>

<style>
/* .modal-dialog.modal-md {
    width: 90% !important;
    max-width: 90% !important;
  } */
  .pull-right{
    float: right
  }

.widget_box {
  min-height: auto !important;
}

.modal-header {
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  background: #ecf2f6;
  /* height: 100px; */
}
</style>




// WEBPACK FOOTER //
// src/components/pages/inventory/index.vue